export const SITE_TITLE = "Unver Lastik";
export const VERSION_ID = "1641297203805";

export const FACEBOOK_URL = "https://www.facebook.com/unverlastikservis";
export const INSTAGRAM_URL = "https://www.instagram.com/unver.lastik/";
export const LINKEDIN_URL = "https://www.linkedin.com/in/%C3%BCnver-lastik-411367204/";
